import styled from '@emotion/styled';
import {TextField} from '@mui/material';

export const InputField = styled(TextField)``;

interface Props {
  disabled: any;
}
export const TextLabelWrapperComponentDiv = styled.div<Props>`
  width: 100%;
  background-color: ${p => (p.disabled ? p.theme.palette.grey[100] : '')};
  border-radius: 6px !important;
`;
